import basePageFields from '@fragments/pages/basePageFields';

import StreamTieredFragment from '@fragments/shared/StreamTieredFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';
import ProjectsSummaryFragment from '@fragments/summaries/ProjectsSummaryFragment';
import ContentDynamicSortableFragment from '@fragments/shared/ContentDynamicSortableFragment';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import SubnavFragment from '@fragments/shared/SubnavFragment';
import AvatarFragment from '@fragments/shared/AvatarFragment';
import SeoFragment from '@fragments/shared/SeoFragment';

export default gql`
    fragment ProjectFragment on Project {
        ${basePageFields}
        dek
        ...ProjectsSummaryFragment
        latestWork {
            ...ContentDynamicSortableFragment
        }
        contributors {
            ...PersonSummaryFragment
        }
        subNav {
            ...SubnavFragment
        }
        heroProgramsProjects {
            heroImage {
                ...ImageSummaryFragment
            }
            mobileHeroImage {
                ...ImageSummaryFragment
            }
            logo {
                ...ImageSummaryFragment
            }
        }
        about
        displayExperts
        streamTiered {
            ...StreamTieredFragment
        }
        syndications {
            programs {
                reference {
                    title
                    path
                    dek
                    contributors {
                        avatar {
                            ...AvatarFragment
                        }
                    }
                }
                isPrimary
            }
            centers {
            global {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
            middleEast {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
            russiaEurasia {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
            india {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
            china {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
            europe {
                syndicated
                isPrimary
                topics {
                    title
                    path
                }
                regions {
                    title
                    path
                }
            }
        }
        }
        socialNetworks {
            handle
            id
            network
        }
        seo {
            ...SeoFragment
        }
    }
    ${AvatarFragment}
    ${SubnavFragment}
    ${ImageSummaryFragment}
    ${StreamTieredFragment}
    ${PersonSummaryFragment}
    ${ProjectsSummaryFragment}
    ${ContentDynamicSortableFragment}
    ${SeoFragment}
`;
